import React, { type FC, type PropsWithChildren } from 'react';

import styled from '@emotion/styled';
import { getColor, variant } from '@lucid/theme';

import type { Lucid } from '../../types/types';
import Box from '../box/box';
import WaveSVG from './wave-svg';

export interface WaveProps {
  /** Allows the component to get additional styles. */
  className?: string;
  /** Will render Wave svg beneath the content */
  hasBottomWave?: boolean;
  /** The background color for the Wave - Use stringified theme value */
  backgroundColor?: Lucid.Theme.Color.ValueKeys | Lucid.Theme.Utility.ProductColorMap;
  /** The available variants for the Wave component. */
  variant?: Lucid.Theme.Component.Wave.VariantKeys;
  /** The current site product. */
  product?: Lucid.Product.Sites;
}

const StyledWave = styled.div<WaveProps>(
  variant({
    scale: 'wave',
  }),
  {
    label: 'wave',
    width: '100%',
  },
);

const Wave: FC<PropsWithChildren<WaveProps>> = ({
  children,
  className,
  hasBottomWave = false,
  backgroundColor = 'primary',
  variant = 'default',
  product = 'co',
  ...rest
}) => (
  <StyledWave {...rest} className={className} variant={variant}>
    {product === 'spark' && (
      <Box css={{ height: 'auto', width: '100%' }}>
        <WaveSVG
          css={theme => ({
            path: {
              fill: getColor({ color: backgroundColor, theme }),
            },
            display: 'block',
            width: '100%',
            marginBottom: '-2px',
          })}
        />
      </Box>
    )}
    <Box
      className="waveChildrenContainer"
      css={theme => ({
        backgroundColor: getColor({ color: backgroundColor, theme }),
      })}
    >
      {children}
    </Box>
    {product === 'spark' && hasBottomWave && (
      <Box css={{ height: 'auto', width: '100%' }}>
        <WaveSVG
          css={theme => ({
            path: {
              fill: getColor({ color: backgroundColor, theme }),
            },
            transform: 'scaleY(-1) scaleX(-1)',
            display: 'block',
            width: '100%',
            marginTop: '-2px',
          })}
        />
      </Box>
    )}
  </StyledWave>
);

export { Wave };
export default Wave;
